export default "__VITE_ASSET__Dcf8$e3k__"